import arrowSvg from './arrow.svg';
import bookMarketerLeftPng from './book-marketer-left.png';
import bookMarketerRightPng from './book-marketer-right.png';
import ClockFreeSvg from './Clock-Free.svg';
import ClockThirtySvg from './Clock-30.svg';
import ClockSixtySvg from './Clock-60.svg';
import downArrowSvg from './down-arrow.svg';
import iconCartSvg from './icon-cart.svg';
import iconCloseSvg from './icon-close.svg';
import iconPhoneSvg from './icon-phone.svg';
import iconLogoSvg from './mt-icon.svg';
import iconLogoWhiteSvg from './mt-icon-white.svg';
import iconPlaySvg from './icon-play.svg';
import iconSignInSvg from './icon-sign-in.svg';
import iconFacebookSvg from './icon-facebook.svg';
import iconInstagramSvg from './icon-instagram.svg';
import iconLinkedinSvg from './icon-linkedin.svg';
import logoSvg from './mt-logo.svg';
import logoWhiteSvg from './mt-logo-white.svg';
import needHelpJpg from './Need-Help.jpg';
import productHeaderTestPng from './ProductHeaderTest.png';
import productPageLeftJpg from './product-page-left.jpg';
import productPageRightJpg from './product-page-right.jpg';
import productsPageBgJpg from './products-page-bg.jpg';
import servicesBannerJpg from './Services-Banner.jpg';

export {
  arrowSvg,
  bookMarketerLeftPng,
  bookMarketerRightPng,
  ClockFreeSvg,
  ClockThirtySvg,
  ClockSixtySvg,
  downArrowSvg,
  iconCartSvg,
  iconCloseSvg,
  iconPhoneSvg,
  iconLogoSvg,
  iconLogoWhiteSvg,
  iconPlaySvg,
  iconSignInSvg,
  iconFacebookSvg,
  iconInstagramSvg,
  iconLinkedinSvg,
  logoSvg,
  logoWhiteSvg,
  needHelpJpg,
  productHeaderTestPng,
  productPageLeftJpg,
  productPageRightJpg,
  productsPageBgJpg,
  servicesBannerJpg,
};



// WEBPACK FOOTER //
// ./src/images/index.js